const baseURLs = {
  local: "http://localhost:3000/api",
  web: "https://officeapi.kaaryaalaya.com/api", // Ensure HTTPS in production
};

// Notification is served from the same backend (port 3000 locally).
const notifURLs = {
  local: "http://localhost:3000",
  web: "https://officeapi.kaaryaalaya.com/",
};


const environment = process.env.NODE_ENV === "production" ? "web" : "local";

export const getURL = () => baseURLs[environment];

export const getNotifURL = () => notifURLs[environment];

export const getImageURL = (url) => `${getURL()}${url}`;

export default {
  getURL,
  getNotifURL,
  getImageURL,
};
